import { Injectable } from "@angular/core";

const HIDDEN_SERVICES_KEY = "sm_hidden_services";
const HIDDEN_LAMBDAS_KEY = "sm_hidden_lambdas";
const HIDDEN_FRONTENDS_KEY = "sm_hidden_frontends";

@Injectable({ providedIn: "root" })
export class HiddenItemsService {
  private hiddenServices: Set<string>;
  private hiddenLambdas: Set<string>;
  private hiddenFrontends: Set<string>;

  constructor() {
    this.hiddenServices = this.loadFromStorage(HIDDEN_SERVICES_KEY);
    this.hiddenLambdas = this.loadFromStorage(HIDDEN_LAMBDAS_KEY);
    this.hiddenFrontends = this.loadFromStorage(HIDDEN_FRONTENDS_KEY);
  }

  private loadFromStorage(key: string): Set<string> {
    try {
      const raw = localStorage.getItem(key);
      return raw ? new Set<string>(JSON.parse(raw)) : new Set<string>();
    } catch {
      return new Set<string>();
    }
  }

  private saveToStorage(key: string, values: Set<string>): void {
    localStorage.setItem(key, JSON.stringify([...values]));
  }

  isServiceHidden(name: string): boolean {
    return this.hiddenServices.has(name);
  }

  isLambdaHidden(name: string): boolean {
    return this.hiddenLambdas.has(name);
  }

  isFrontendHidden(name: string): boolean {
    return this.hiddenFrontends.has(name);
  }

  toggleService(name: string): void {
    if (this.hiddenServices.has(name)) {
      this.hiddenServices.delete(name);
    } else {
      this.hiddenServices.add(name);
    }
    this.saveToStorage(HIDDEN_SERVICES_KEY, this.hiddenServices);
  }

  toggleLambda(name: string): void {
    if (this.hiddenLambdas.has(name)) {
      this.hiddenLambdas.delete(name);
    } else {
      this.hiddenLambdas.add(name);
    }
    this.saveToStorage(HIDDEN_LAMBDAS_KEY, this.hiddenLambdas);
  }

  toggleFrontend(name: string): void {
    if (this.hiddenFrontends.has(name)) {
      this.hiddenFrontends.delete(name);
    } else {
      this.hiddenFrontends.add(name);
    }
    this.saveToStorage(HIDDEN_FRONTENDS_KEY, this.hiddenFrontends);
  }

  resetAll(): void {
    this.hiddenServices.clear();
    this.hiddenLambdas.clear();
    this.hiddenFrontends.clear();
    localStorage.removeItem(HIDDEN_SERVICES_KEY);
    localStorage.removeItem(HIDDEN_LAMBDAS_KEY);
    localStorage.removeItem(HIDDEN_FRONTENDS_KEY);
  }

  get hiddenServicesCount(): number {
    return this.hiddenServices.size;
  }

  get hiddenLambdasCount(): number {
    return this.hiddenLambdas.size;
  }

  get hiddenFrontendsCount(): number {
    return this.hiddenFrontends.size;
  }
}
